module.exports = __webpack_public_path__ + "static/image3-2672c7e89d08a881b23eb3145919bc70.jpg";